import styled from 'styled-components';
import { Colors, AxlModal } from 'axl-reactjs-ui';

export const Contain = styled.div`
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
`;

export const Col = styled.div`
  flex: 1;
  padding: 10px;
`;

export const Inner = styled.div`
  width: 1600px;
  max-width: 100%;
  margin: 0 auto;
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 10px 0;
  @media (max-width: 567px) {
    flex-direction: column;
  }
`;

export const Main = styled.div`
  display: flex;
  margin: 0;
`;

export const Title = styled.div`
  flex: 1;
  text-align: left;
  font-family: 'AvenirNext-Medium';
  font-size: 18px;
  font-weight: 500;
  color: #3b3b3b;
`;

export const Section = styled.div`
  flex: 1;
  padding: 0 10px;
  height: 100%;
`;
export const EmptyPanel = styled.div`
  flex: 2;
  padding: 0 10px;
`;
export const Empty = styled.div`
  margin-top: 30px;
`;

export const Panel = styled.div`
    border-radius: 5px;
    padding: 10px 0 0;
    height: 100%;
    box-sizing: border-box;
`;

export const PanelDetail = styled(Panel)`
  padding: 0;
  background-color: #FFF;
  overflow: hidden;
`;

export const Text = styled.p`
  font-family: 'AvenirNext';
  font-size: 14px;
  line-height: 25px;
  text-align: center;
  color: #000000;
  margin: 0;
`;

export const GroupControls = styled.div``;

export default {
  Modal: {
    borderRadius: 5
  }
}
